// extracted by mini-css-extract-plugin
export default {"btn":"ButtonZakaz_btn__0y0kl","btn_d":"ButtonZakaz_btn_d__lBEMJ","btn_i":"ButtonZakaz_btn_i__TFrvK","count":"ButtonZakaz_count__3qdOD"};